import { ReactNode } from 'react';
import { useFormContext, get } from 'react-hook-form';
import { Spinner } from './ui';

interface FieldProps {
    name: string;
    label: ReactNode;
    required?: boolean;
    children: ReactNode;
    help?: ReactNode;
    /** async stav pole: spinner při ověřování, fajfka po úspěchu */
    status?: 'loading' | 'valid' | null;
}

/**
 * Řádek formuláře v layoutu košíku (label + input + chybová hláška + stavová
 * ikona). Používá stejné CSS třídy jako Latte šablona, aby vzhled zůstal
 * konzistentní; interakce dodává checkout.css (.rc-*).
 */
export default function Field({ name, label, required, children, help, status = null }: FieldProps) {
    const { formState } = useFormContext();
    const error = get(formState.errors, name) as { message?: string } | undefined;

    return (
        <div className="clearfix">
            <div className={`form-group col-xm-6 col-md-5 no-padding--left${error ? ' has-error' : ''}`}>
                <label className="control-label" htmlFor={`frm-${name.replace(/\./g, '-')}`}>
                    {label} {required && <span>*</span>}
                </label>
                <div className="rc-input-wrap">
                    {children}
                    {status === 'loading' && (
                        <span className="rc-input-icon"><Spinner /></span>
                    )}
                    {status === 'valid' && !error && (
                        <span className="rc-input-icon rc-input-icon--valid" aria-hidden="true">✓</span>
                    )}
                </div>
                {error?.message && <p className="msg msg--error rc-msg">{error.message}</p>}
            </div>
            {help && <div className="col-xm-6 col-md-7 basket__help no-padding--left">{help}</div>}
        </div>
    );
}
